import { Dialog, DialogContent } from '@mui/material';
import { useEffect, useState } from 'react';
import EmptyState, { EmptyStateProps } from './EmptyState';
import ModalX from './Modal-X';

interface EmptyStateDialogProps extends EmptyStateProps {
  open: boolean;
  onClose: () => void;
}

const EmptyStateDialog = ({ open, onClose, ...emptyStateProps }: EmptyStateDialogProps) => {
  const [isOpen, setIsOpen] = useState(open);

  const onCloseHandler = () => {
    setIsOpen(false);
    onClose();
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Dialog open={isOpen} onClose={onCloseHandler}>
      <DialogContent>
        <ModalX close={onCloseHandler} />
        <EmptyState card={false} {...emptyStateProps} />
      </DialogContent>
    </Dialog>
  );
};

export default EmptyStateDialog;
